var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivitiesIconTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.596,
    height: 19.506,
    viewBox: "0 0 16.596 19.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V1H0z",
    transform: "translate(-542.36 -815.465) rotate(45 -729.348 1073.582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V1H0z",
    transform: "translate(-542.36 -815.465) rotate(45 -724.659 1087.091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V1H0z",
    transform: "translate(-542.36 -815.465) rotate(45 -729.122 1085.682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V1H0z",
    transform: "translate(-542.36 -815.465) rotate(45 -732.628 1075.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.956 828.743h-7.441v-4.234l1.384-1.384a2.929 2.929 0 0 0 3.7-.363c1.144-1.144 2.02-6.163 2.02-6.163s-5.018.877-6.162 2.021a2.919 2.919 0 0 0-.272 3.808l-1.055 1.055-2.268-2.268a2.925 2.925 0 0 0-.337-3.73c-1.143-1.144-6.162-2.02-6.162-2.02s.877 5.018 2.02 6.162a2.922 2.922 0 0 0 3.776.3l2.359 2.36v4.457h-7.44v1h6.733l-2.563 2.564.707.707 2.563-2.563v4.148h1v-4l1.542 1.541.707-.707-1.684-1.684h6.876z",
    transform: "translate(-542.36 -815.465)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesIconTool);
export default __webpack_public_path__ + "static/media/activities-icon-tool.9fd9af36.svg";
export { ForwardRef as ReactComponent };